import './CrossHair.css'

export const CrossHair = () => {
    return (
        <div className="crosshair">
            <div className="crosshair__vertical"></div>
            <div className="crosshair__horizontal"></div>
        </div>
    );
};
